var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 18C25 21.866 21.866 25 18 25C14.134 25 11 21.866 11 18C11 14.134 14.134 11 18 11C21.866 11 25 14.134 25 18ZM14.8804 14.88C15.1538 14.6067 15.597 14.6067 15.8704 14.88L18 17.0097L20.1297 14.88C20.4031 14.6067 20.8463 14.6067 21.1197 14.88C21.393 15.1534 21.393 15.5966 21.1197 15.87L18.99 17.9997L21.1199 20.1296C21.3933 20.403 21.3933 20.8462 21.1199 21.1195C20.8466 21.3929 20.4033 21.3929 20.13 21.1195L18 18.9896L15.8701 21.1195C15.5967 21.3929 15.1535 21.3929 14.8802 21.1195C14.6068 20.8462 14.6068 20.403 14.8802 20.1296L17.0101 17.9997L14.8804 15.87C14.607 15.5966 14.607 15.1534 14.8804 14.88Z",
    fill: "#808187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.0b6306a97549bd422ee0f09cb4ba4a04.svg";
export { ForwardRef as ReactComponent };